import { render, staticRenderFns } from "./patientCardIncubators.vue?vue&type=template&id=776e885e&scoped=true"
import script from "./patientCardIncubators.vue?vue&type=script&lang=js"
export * from "./patientCardIncubators.vue?vue&type=script&lang=js"
import style0 from "./patientCardIncubators.vue?vue&type=style&index=0&id=776e885e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e885e",
  null
  
)

export default component.exports